import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const ChevronRight = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="chevron right icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.56778 21.4142C5.78673 20.6332 5.78673 19.3668 6.56778 18.5858L13.1536 12L6.56778 5.41421C5.78673 4.63316 5.78673 3.36683 6.56778 2.58579C7.34883 1.80474 8.61516 1.80474 9.39621 2.58579L18.8104 12L9.39621 21.4142C8.61516 22.1953 7.34883 22.1953 6.56778 21.4142Z"
    />
  </svg>
)
